import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { Field, Form } from 'react-final-form';
import classNames from 'classnames/bind';
import Textfield from "../../../Textfield";
import { ArrowRight } from "../../../icons";
import styles from './Form.css';
var cx = classNames.bind(styles);

var FooterForm = function FooterForm(_ref) {
  var onSubmit = _ref.onSubmit,
      validate = _ref.validate;
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    validate: validate,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
          submitting = _ref2.submitting,
          pristine = _ref2.pristine,
          invalid = _ref2.invalid;
      return /*#__PURE__*/React.createElement("form", {
        className: cx('FormEmail'),
        onSubmit: handleSubmit
      }, /*#__PURE__*/React.createElement(Field, {
        name: "email"
      }, function (_ref3) {
        var input = _ref3.input,
            meta = _ref3.meta;
        var error = meta.invalid ? meta.error : '';
        return /*#__PURE__*/React.createElement(Textfield, _extends({}, input, {
          type: "email",
          label: "E-mail",
          invalid: meta.invalid,
          tooltip: error
        }));
      }), /*#__PURE__*/React.createElement("button", {
        className: cx('Submit'),
        type: "submit",
        disabled: pristine || invalid || submitting
      }, "Submit", /*#__PURE__*/React.createElement(ArrowRight, null)));
    }
  });
};

export default FooterForm;